<script>
  import { BreadcrumbItem } from 'element-ui'
  export default {
    name:'ElBreadcrumbItem',
    extends:BreadcrumbItem
  }
</script>
